import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

// Record-book breadcrumb back-link: small, uppercase, tracked. Sits on its own
// line above a page title so it never pinches the heading. Pass `to` for a
// route, or `onClick` for a custom handler (e.g. history.back / step back).
interface BackLinkProps {
  to?: string;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
}

const baseClass =
  'inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-secondary-600 hover:text-ink-900 transition-colors';

export default function BackLink({ to, onClick, children, className = '' }: BackLinkProps) {
  const cls = `${baseClass} ${className}`.trim();
  const inner = (
    <>
      <ArrowLeftIcon className="w-4 h-4" />
      {children}
    </>
  );
  if (to) {
    return (
      <Link to={to} onClick={onClick} className={cls}>
        {inner}
      </Link>
    );
  }
  return (
    <button type="button" onClick={onClick} className={cls}>
      {inner}
    </button>
  );
}
